// generated with @7nohe/openapi-react-query-codegen@2.0.0

import { type Options } from "@hey-api/client-fetch";
import { UseQueryResult } from "@tanstack/react-query";
import {
  acceptOffer,
  addFormSchoolTag,
  addFormTag,
  addOfferingSeatTypes,
  addSchoolToForm,
  archiveTeamMembers,
  bulkAcceptOffer,
  bulkDeclineOffer,
  bulkGetOfferExpirationInfo,
  bulkMakeOffers,
  bulkRevokeOffer,
  bulkSetOfferExpiration,
  cancelPayment,
  checkEligibility,
  checkout,
  clearAnswer,
  clearAnswerForMe,
  clearSubStatus,
  connectStripeAccount,
  createApiCredential,
  createBoundaryConnections,
  createBulkFormAction,
  createBulkFormTagAction,
  createBulkOfferAction,
  createBulkSubstatusAction,
  createBulkWaitlistAction,
  createFamily,
  createFormForAdmin,
  createFormRule,
  createFormTemplate,
  createLoginPrefillToken,
  createMatchRun,
  createOfferConfiguration,
  createOfferingCategories,
  createOfferings,
  createOrganization,
  createPaymentTemplate,
  createPayments,
  createRuleExecutions,
  createRuleExecutionsForMe,
  createTag,
  createTagGroup,
  createTeamMember,
  declineOffer,
  deleteApiCredential,
  deleteBoundaries,
  deleteBoundaryConnections,
  deleteFormForMe,
  deleteFormRule,
  deleteOfferConfiguration,
  deleteOffering,
  deleteOfferingCategory,
  deleteOfferingSeatType,
  deletePaymentTemplate,
  deleteTag,
  deleteTagGroup,
  deleteUnpublishedFormSchema,
  deleteWaitlists,
  diffFormSchema,
  disconnectStripeAccount,
  editTeamMember,
  exclude,
  exportBoundariesByOrgGeoJson,
  exportBoundaryGeoJson,
  exportBulkActionItems,
  exportCapacitiesByEnrollmentPeriod,
  exportCapacitiesBySchoolAndEnrollmentPeriod,
  exportFormTemplate,
  exportMessageTemplates,
  exportRuleConfiguration,
  exportSchoolBoundaryConnections,
  exportSchoolsAndGradesForEnrollmentPeriod,
  fetchFormSchoolTags,
  fetchFormTags,
  fetchTagGroups,
  fetchTags,
  generateBannerImageUploadUrl,
  generateUploadUrl,
  geocodeAnswer,
  geocodeForms,
  getActiveFormsForApplicant,
  getAdminGreeting,
  getAdminPaymentReceipt,
  getAdmissionsForMe,
  getAnswers,
  getAnswersForMe,
  getApiCredential,
  getBoundaries,
  getBoundariesByOrgId,
  getBoundariesMetadata,
  getBoundaryConnectionsBySchoolId,
  getBoundaryMapByEnrollmentPeriodId,
  getBoundaryMapByEnrollmentPeriodIdOptimized,
  getBoundaryMapByFormId,
  getBoundaryMapByFormIdOptimized,
  getBulkAction,
  getBulkActionProgress,
  getCapacitiesBySchoolAndEnrollmentPeriod,
  getCapacitiesConfigByEnrollmentPeriod,
  getCapacitiesHistory,
  getCapacitiesHistoryDetail,
  getCapacitySummaryByEnrollmentPeriod,
  getDashboardFormResponsesOverTime,
  getDashboardFormSchoolGradeRank,
  getDashboardFormStatus,
  getDashboardFormSubstatus,
  getEligibleFormTemplatesForApplicant,
  getEligibleFormTemplatesForMe,
  getForm,
  getFormAlertsByFormId,
  getFormRule,
  getFormTemplate,
  getFormTemplateSettings,
  getFormTemplateSettingsForMe,
  getForms,
  getGradeConfigByEnrollmentPeriod,
  getMatchRun,
  getMatchRunDetails,
  getOfferConfigurationById,
  getOfferConfigurationsByEnrollmentPeriodId,
  getOfferConfigurationsByFormTemplateId,
  getOfferingCategories,
  getOfferings,
  getOffersForMe,
  getOrganizationConfig,
  getPaymentReceipt,
  getPaymentTemplate,
  getPaymentsForMe,
  getSchools,
  getSchoolsByEnrollmentPeriod,
  getStaffCreatePrecheck,
  getTagUsageCount,
  importBoundaryConnectionsFromEnrollmentPeriod,
  importCapacitiesByEnrollmentPeriod,
  importFormTemplateFromJson,
  importFormTemplateFromOther,
  importMessageTemplates,
  importMessageTemplatesFromOther,
  importRuleConfiguration,
  importSchoolBoundaryConnections,
  importSchoolsAndGradesForEnrollmentPeriod,
  importSchoolsAndGradesFromOthersForEnrollmentPeriod,
  listAllowedSubStatusTransitions,
  listApiCredentials,
  listBulkActionItems,
  listBulkActions,
  listCapacitiesByEnrollmentPeriod,
  listCapacitiesBySchoolAndEnrollmentPeriod,
  listFormIds,
  listFormIdsAdvanced,
  listFormIdsAdvancedV2,
  listFormIdsV2,
  listFormTemplatesSettings,
  listForms,
  listFormsAdvanced,
  listFormsFromSelection,
  listMatchRuns,
  listPaymentTemplates,
  listPayments,
  listTeams,
  listUserGroups,
  parentGetBoundaryMapByEnrollmentPeriodId,
  parentGetBoundaryMapByEnrollmentPeriodIdOptimized,
  parentGetBoundaryMapByFormId,
  parentGetBoundaryMapByFormIdOptimized,
  postBoundaries,
  postWaitlists,
  publishFormSchema,
  publishMatchRun,
  putAnswer,
  putAnswerForMe,
  putAnswers,
  putAnswersForMe,
  removeFormSchoolTag,
  removeFormTag,
  resendVerificationEmail,
  resetFormForMe,
  resetTeamMemberMfa,
  rotateApiCredentialSecret,
  searchApplicantDuplicates,
  searchApplicants,
  searchParents,
  sendPasswordReset,
  submitFormForMe,
  updateApiCredential,
  updateBoundaryById,
  updateBoundaryConnections,
  updateCapacitiesByEnrollmentPeriod,
  updateCapacitiesConfigByEnrollmentPeriod,
  updateFormRule,
  updateFormRuleActiveStatus,
  updateFormSchema,
  updateFormTemplate,
  updateFormTemplateSettings,
  updateFormsStatusForAdmin,
  updateOfferConfiguration,
  updateOfferingCategory,
  updateOrganizationConfig,
  updatePaymentTemplate,
  updateTag,
  updateTagGroup,
  validateFormSchema,
  withdrawFromWaitlist,
} from "../requests/services.gen";
import {
  ExportBoundariesByOrgGeoJsonData,
  ExportBoundaryGeoJsonData,
  ExportBulkActionItemsData,
  ExportFormTemplateData,
  ExportMessageTemplatesData,
  ExportRuleConfigurationData,
  ExportSchoolBoundaryConnectionsData,
  ExportSchoolsAndGradesForEnrollmentPeriodData,
  FetchFormSchoolTagsData,
  FetchFormTagsData,
  FetchTagGroupsData,
  FetchTagsData,
  GetActiveFormsForApplicantData,
  GetAdminGreetingData,
  GetAdminPaymentReceiptData,
  GetAdmissionsForMeData,
  GetAnswersData,
  GetAnswersForMeData,
  GetApiCredentialData,
  GetBoundariesByOrgIdData,
  GetBoundariesData,
  GetBoundariesMetadataData,
  GetBoundaryConnectionsBySchoolIdData,
  GetBoundaryMapByEnrollmentPeriodIdData,
  GetBoundaryMapByEnrollmentPeriodIdOptimizedData,
  GetBoundaryMapByFormIdData,
  GetBoundaryMapByFormIdOptimizedData,
  GetBulkActionData,
  GetBulkActionProgressData,
  GetCapacitiesBySchoolAndEnrollmentPeriodData,
  GetCapacitiesConfigByEnrollmentPeriodData,
  GetCapacitiesHistoryData,
  GetCapacitiesHistoryDetailData,
  GetCapacitySummaryByEnrollmentPeriodData,
  GetDashboardFormResponsesOverTimeData,
  GetDashboardFormSchoolGradeRankData,
  GetDashboardFormStatusData,
  GetDashboardFormSubstatusData,
  GetEligibleFormTemplatesForApplicantData,
  GetEligibleFormTemplatesForMeData,
  GetFormAlertsByFormIdData,
  GetFormData,
  GetFormRuleData,
  GetFormTemplateData,
  GetFormTemplateSettingsData,
  GetFormTemplateSettingsForMeData,
  GetGradeConfigByEnrollmentPeriodData,
  GetMatchRunData,
  GetMatchRunDetailsData,
  GetOfferConfigurationByIdData,
  GetOfferConfigurationsByEnrollmentPeriodIdData,
  GetOfferConfigurationsByFormTemplateIdData,
  GetOfferingCategoriesData,
  GetOfferingsData,
  GetOffersForMeData,
  GetOrganizationConfigData,
  GetPaymentReceiptData,
  GetPaymentTemplateData,
  GetPaymentsForMeData,
  GetSchoolsByEnrollmentPeriodData,
  GetSchoolsData,
  GetStaffCreatePrecheckData,
  GetTagUsageCountData,
  ListApiCredentialsData,
  ListBulkActionItemsData,
  ListBulkActionsData,
  ListCapacitiesByEnrollmentPeriodData,
  ListCapacitiesBySchoolAndEnrollmentPeriodData,
  ListFormIdsData,
  ListFormIdsV2Data,
  ListFormTemplatesSettingsData,
  ListFormsData,
  ListMatchRunsData,
  ListPaymentTemplatesData,
  ListPaymentsData,
  ListTeamsData,
  ParentGetBoundaryMapByEnrollmentPeriodIdData,
  ParentGetBoundaryMapByEnrollmentPeriodIdOptimizedData,
  ParentGetBoundaryMapByFormIdData,
  ParentGetBoundaryMapByFormIdOptimizedData,
  SearchApplicantDuplicatesData,
  SearchApplicantsData,
  SearchParentsData,
} from "../requests/types.gen";
export type GetStaffCreatePrecheckDefaultResponse = Awaited<
  ReturnType<typeof getStaffCreatePrecheck>
>["data"];
export type GetStaffCreatePrecheckQueryResult<
  TData = GetStaffCreatePrecheckDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetStaffCreatePrecheckKey = "GetStaffCreatePrecheck";
export const UseGetStaffCreatePrecheckKeyFn = (
  clientOptions: Options<GetStaffCreatePrecheckData, true>,
  queryKey?: Array<unknown>
) => [useGetStaffCreatePrecheckKey, ...(queryKey ?? [clientOptions])];
export type GetActiveFormsForApplicantDefaultResponse = Awaited<
  ReturnType<typeof getActiveFormsForApplicant>
>["data"];
export type GetActiveFormsForApplicantQueryResult<
  TData = GetActiveFormsForApplicantDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetActiveFormsForApplicantKey = "GetActiveFormsForApplicant";
export const UseGetActiveFormsForApplicantKeyFn = (
  clientOptions: Options<GetActiveFormsForApplicantData, true>,
  queryKey?: Array<unknown>
) => [useGetActiveFormsForApplicantKey, ...(queryKey ?? [clientOptions])];
export type GetFormDefaultResponse = Awaited<
  ReturnType<typeof getForm>
>["data"];
export type GetFormQueryResult<
  TData = GetFormDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetFormKey = "GetForm";
export const UseGetFormKeyFn = (
  clientOptions: Options<GetFormData, true>,
  queryKey?: Array<unknown>
) => [useGetFormKey, ...(queryKey ?? [clientOptions])];
export type GetAnswersDefaultResponse = Awaited<
  ReturnType<typeof getAnswers>
>["data"];
export type GetAnswersQueryResult<
  TData = GetAnswersDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetAnswersKey = "GetAnswers";
export const UseGetAnswersKeyFn = (
  clientOptions: Options<GetAnswersData, true>,
  queryKey?: Array<unknown>
) => [useGetAnswersKey, ...(queryKey ?? [clientOptions])];
export type GetOfferConfigurationByIdDefaultResponse = Awaited<
  ReturnType<typeof getOfferConfigurationById>
>["data"];
export type GetOfferConfigurationByIdQueryResult<
  TData = GetOfferConfigurationByIdDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetOfferConfigurationByIdKey = "GetOfferConfigurationById";
export const UseGetOfferConfigurationByIdKeyFn = (
  clientOptions: Options<GetOfferConfigurationByIdData, true>,
  queryKey?: Array<unknown>
) => [useGetOfferConfigurationByIdKey, ...(queryKey ?? [clientOptions])];
export type GetOfferConfigurationsByEnrollmentPeriodIdDefaultResponse = Awaited<
  ReturnType<typeof getOfferConfigurationsByEnrollmentPeriodId>
>["data"];
export type GetOfferConfigurationsByEnrollmentPeriodIdQueryResult<
  TData = GetOfferConfigurationsByEnrollmentPeriodIdDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetOfferConfigurationsByEnrollmentPeriodIdKey =
  "GetOfferConfigurationsByEnrollmentPeriodId";
export const UseGetOfferConfigurationsByEnrollmentPeriodIdKeyFn = (
  clientOptions: Options<GetOfferConfigurationsByEnrollmentPeriodIdData, true>,
  queryKey?: Array<unknown>
) => [
  useGetOfferConfigurationsByEnrollmentPeriodIdKey,
  ...(queryKey ?? [clientOptions]),
];
export type GetOfferConfigurationsByFormTemplateIdDefaultResponse = Awaited<
  ReturnType<typeof getOfferConfigurationsByFormTemplateId>
>["data"];
export type GetOfferConfigurationsByFormTemplateIdQueryResult<
  TData = GetOfferConfigurationsByFormTemplateIdDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetOfferConfigurationsByFormTemplateIdKey =
  "GetOfferConfigurationsByFormTemplateId";
export const UseGetOfferConfigurationsByFormTemplateIdKeyFn = (
  clientOptions: Options<GetOfferConfigurationsByFormTemplateIdData, true>,
  queryKey?: Array<unknown>
) => [
  useGetOfferConfigurationsByFormTemplateIdKey,
  ...(queryKey ?? [clientOptions]),
];
export type ListFormsDefaultResponse = Awaited<
  ReturnType<typeof listForms>
>["data"];
export type ListFormsQueryResult<
  TData = ListFormsDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useListFormsKey = "ListForms";
export const UseListFormsKeyFn = (
  clientOptions: Options<ListFormsData, true>,
  queryKey?: Array<unknown>
) => [useListFormsKey, ...(queryKey ?? [clientOptions])];
export type ListFormIdsDefaultResponse = Awaited<
  ReturnType<typeof listFormIds>
>["data"];
export type ListFormIdsQueryResult<
  TData = ListFormIdsDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useListFormIdsKey = "ListFormIds";
export const UseListFormIdsKeyFn = (
  clientOptions: Options<ListFormIdsData, true>,
  queryKey?: Array<unknown>
) => [useListFormIdsKey, ...(queryKey ?? [clientOptions])];
export type ListFormIdsV2DefaultResponse = Awaited<
  ReturnType<typeof listFormIdsV2>
>["data"];
export type ListFormIdsV2QueryResult<
  TData = ListFormIdsV2DefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useListFormIdsV2Key = "ListFormIdsV2";
export const UseListFormIdsV2KeyFn = (
  clientOptions: Options<ListFormIdsV2Data, true>,
  queryKey?: Array<unknown>
) => [useListFormIdsV2Key, ...(queryKey ?? [clientOptions])];
export type ListBulkActionsDefaultResponse = Awaited<
  ReturnType<typeof listBulkActions>
>["data"];
export type ListBulkActionsQueryResult<
  TData = ListBulkActionsDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useListBulkActionsKey = "ListBulkActions";
export const UseListBulkActionsKeyFn = (
  clientOptions: Options<ListBulkActionsData, true>,
  queryKey?: Array<unknown>
) => [useListBulkActionsKey, ...(queryKey ?? [clientOptions])];
export type GetBulkActionProgressDefaultResponse = Awaited<
  ReturnType<typeof getBulkActionProgress>
>["data"];
export type GetBulkActionProgressQueryResult<
  TData = GetBulkActionProgressDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetBulkActionProgressKey = "GetBulkActionProgress";
export const UseGetBulkActionProgressKeyFn = (
  clientOptions: Options<GetBulkActionProgressData, true>,
  queryKey?: Array<unknown>
) => [useGetBulkActionProgressKey, ...(queryKey ?? [clientOptions])];
export type GetBulkActionDefaultResponse = Awaited<
  ReturnType<typeof getBulkAction>
>["data"];
export type GetBulkActionQueryResult<
  TData = GetBulkActionDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetBulkActionKey = "GetBulkAction";
export const UseGetBulkActionKeyFn = (
  clientOptions: Options<GetBulkActionData, true>,
  queryKey?: Array<unknown>
) => [useGetBulkActionKey, ...(queryKey ?? [clientOptions])];
export type ExportBulkActionItemsDefaultResponse = Awaited<
  ReturnType<typeof exportBulkActionItems>
>["data"];
export type ExportBulkActionItemsQueryResult<
  TData = ExportBulkActionItemsDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useExportBulkActionItemsKey = "ExportBulkActionItems";
export const UseExportBulkActionItemsKeyFn = (
  clientOptions: Options<ExportBulkActionItemsData, true>,
  queryKey?: Array<unknown>
) => [useExportBulkActionItemsKey, ...(queryKey ?? [clientOptions])];
export type ListBulkActionItemsDefaultResponse = Awaited<
  ReturnType<typeof listBulkActionItems>
>["data"];
export type ListBulkActionItemsQueryResult<
  TData = ListBulkActionItemsDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useListBulkActionItemsKey = "ListBulkActionItems";
export const UseListBulkActionItemsKeyFn = (
  clientOptions: Options<ListBulkActionItemsData, true>,
  queryKey?: Array<unknown>
) => [useListBulkActionItemsKey, ...(queryKey ?? [clientOptions])];
export type FetchFormTagsDefaultResponse = Awaited<
  ReturnType<typeof fetchFormTags>
>["data"];
export type FetchFormTagsQueryResult<
  TData = FetchFormTagsDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useFetchFormTagsKey = "FetchFormTags";
export const UseFetchFormTagsKeyFn = (
  clientOptions: Options<FetchFormTagsData, true>,
  queryKey?: Array<unknown>
) => [useFetchFormTagsKey, ...(queryKey ?? [clientOptions])];
export type FetchFormSchoolTagsDefaultResponse = Awaited<
  ReturnType<typeof fetchFormSchoolTags>
>["data"];
export type FetchFormSchoolTagsQueryResult<
  TData = FetchFormSchoolTagsDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useFetchFormSchoolTagsKey = "FetchFormSchoolTags";
export const UseFetchFormSchoolTagsKeyFn = (
  clientOptions: Options<FetchFormSchoolTagsData, true>,
  queryKey?: Array<unknown>
) => [useFetchFormSchoolTagsKey, ...(queryKey ?? [clientOptions])];
export type FetchTagGroupsDefaultResponse = Awaited<
  ReturnType<typeof fetchTagGroups>
>["data"];
export type FetchTagGroupsQueryResult<
  TData = FetchTagGroupsDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useFetchTagGroupsKey = "FetchTagGroups";
export const UseFetchTagGroupsKeyFn = (
  clientOptions: Options<FetchTagGroupsData, true> = {},
  queryKey?: Array<unknown>
) => [useFetchTagGroupsKey, ...(queryKey ?? [clientOptions])];
export type FetchTagsDefaultResponse = Awaited<
  ReturnType<typeof fetchTags>
>["data"];
export type FetchTagsQueryResult<
  TData = FetchTagsDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useFetchTagsKey = "FetchTags";
export const UseFetchTagsKeyFn = (
  clientOptions: Options<FetchTagsData, true> = {},
  queryKey?: Array<unknown>
) => [useFetchTagsKey, ...(queryKey ?? [clientOptions])];
export type GetTagUsageCountDefaultResponse = Awaited<
  ReturnType<typeof getTagUsageCount>
>["data"];
export type GetTagUsageCountQueryResult<
  TData = GetTagUsageCountDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetTagUsageCountKey = "GetTagUsageCount";
export const UseGetTagUsageCountKeyFn = (
  clientOptions: Options<GetTagUsageCountData, true>,
  queryKey?: Array<unknown>
) => [useGetTagUsageCountKey, ...(queryKey ?? [clientOptions])];
export type ExportRuleConfigurationDefaultResponse = Awaited<
  ReturnType<typeof exportRuleConfiguration>
>["data"];
export type ExportRuleConfigurationQueryResult<
  TData = ExportRuleConfigurationDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useExportRuleConfigurationKey = "ExportRuleConfiguration";
export const UseExportRuleConfigurationKeyFn = (
  clientOptions: Options<ExportRuleConfigurationData, true>,
  queryKey?: Array<unknown>
) => [useExportRuleConfigurationKey, ...(queryKey ?? [clientOptions])];
export type GetEligibleFormTemplatesForApplicantDefaultResponse = Awaited<
  ReturnType<typeof getEligibleFormTemplatesForApplicant>
>["data"];
export type GetEligibleFormTemplatesForApplicantQueryResult<
  TData = GetEligibleFormTemplatesForApplicantDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetEligibleFormTemplatesForApplicantKey =
  "GetEligibleFormTemplatesForApplicant";
export const UseGetEligibleFormTemplatesForApplicantKeyFn = (
  clientOptions: Options<GetEligibleFormTemplatesForApplicantData, true>,
  queryKey?: Array<unknown>
) => [
  useGetEligibleFormTemplatesForApplicantKey,
  ...(queryKey ?? [clientOptions]),
];
export type ListFormTemplatesSettingsDefaultResponse = Awaited<
  ReturnType<typeof listFormTemplatesSettings>
>["data"];
export type ListFormTemplatesSettingsQueryResult<
  TData = ListFormTemplatesSettingsDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useListFormTemplatesSettingsKey = "ListFormTemplatesSettings";
export const UseListFormTemplatesSettingsKeyFn = (
  clientOptions: Options<ListFormTemplatesSettingsData, true>,
  queryKey?: Array<unknown>
) => [useListFormTemplatesSettingsKey, ...(queryKey ?? [clientOptions])];
export type GetFormTemplateDefaultResponse = Awaited<
  ReturnType<typeof getFormTemplate>
>["data"];
export type GetFormTemplateQueryResult<
  TData = GetFormTemplateDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetFormTemplateKey = "GetFormTemplate";
export const UseGetFormTemplateKeyFn = (
  clientOptions: Options<GetFormTemplateData, true>,
  queryKey?: Array<unknown>
) => [useGetFormTemplateKey, ...(queryKey ?? [clientOptions])];
export type GetFormTemplateSettingsDefaultResponse = Awaited<
  ReturnType<typeof getFormTemplateSettings>
>["data"];
export type GetFormTemplateSettingsQueryResult<
  TData = GetFormTemplateSettingsDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetFormTemplateSettingsKey = "GetFormTemplateSettings";
export const UseGetFormTemplateSettingsKeyFn = (
  clientOptions: Options<GetFormTemplateSettingsData, true>,
  queryKey?: Array<unknown>
) => [useGetFormTemplateSettingsKey, ...(queryKey ?? [clientOptions])];
export type ExportFormTemplateDefaultResponse = Awaited<
  ReturnType<typeof exportFormTemplate>
>["data"];
export type ExportFormTemplateQueryResult<
  TData = ExportFormTemplateDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useExportFormTemplateKey = "ExportFormTemplate";
export const UseExportFormTemplateKeyFn = (
  clientOptions: Options<ExportFormTemplateData, true>,
  queryKey?: Array<unknown>
) => [useExportFormTemplateKey, ...(queryKey ?? [clientOptions])];
export type GetFormRuleDefaultResponse = Awaited<
  ReturnType<typeof getFormRule>
>["data"];
export type GetFormRuleQueryResult<
  TData = GetFormRuleDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetFormRuleKey = "GetFormRule";
export const UseGetFormRuleKeyFn = (
  clientOptions: Options<GetFormRuleData, true>,
  queryKey?: Array<unknown>
) => [useGetFormRuleKey, ...(queryKey ?? [clientOptions])];
export type ExportMessageTemplatesDefaultResponse = Awaited<
  ReturnType<typeof exportMessageTemplates>
>["data"];
export type ExportMessageTemplatesQueryResult<
  TData = ExportMessageTemplatesDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useExportMessageTemplatesKey = "ExportMessageTemplates";
export const UseExportMessageTemplatesKeyFn = (
  clientOptions: Options<ExportMessageTemplatesData, true>,
  queryKey?: Array<unknown>
) => [useExportMessageTemplatesKey, ...(queryKey ?? [clientOptions])];
export type ExportSchoolsAndGradesForEnrollmentPeriodDefaultResponse = Awaited<
  ReturnType<typeof exportSchoolsAndGradesForEnrollmentPeriod>
>["data"];
export type ExportSchoolsAndGradesForEnrollmentPeriodQueryResult<
  TData = ExportSchoolsAndGradesForEnrollmentPeriodDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useExportSchoolsAndGradesForEnrollmentPeriodKey =
  "ExportSchoolsAndGradesForEnrollmentPeriod";
export const UseExportSchoolsAndGradesForEnrollmentPeriodKeyFn = (
  clientOptions: Options<ExportSchoolsAndGradesForEnrollmentPeriodData, true>,
  queryKey?: Array<unknown>
) => [
  useExportSchoolsAndGradesForEnrollmentPeriodKey,
  ...(queryKey ?? [clientOptions]),
];
export type ExportSchoolBoundaryConnectionsDefaultResponse = Awaited<
  ReturnType<typeof exportSchoolBoundaryConnections>
>["data"];
export type ExportSchoolBoundaryConnectionsQueryResult<
  TData = ExportSchoolBoundaryConnectionsDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useExportSchoolBoundaryConnectionsKey =
  "ExportSchoolBoundaryConnections";
export const UseExportSchoolBoundaryConnectionsKeyFn = (
  clientOptions: Options<ExportSchoolBoundaryConnectionsData, true>,
  queryKey?: Array<unknown>
) => [useExportSchoolBoundaryConnectionsKey, ...(queryKey ?? [clientOptions])];
export type GetOfferingCategoriesDefaultResponse = Awaited<
  ReturnType<typeof getOfferingCategories>
>["data"];
export type GetOfferingCategoriesQueryResult<
  TData = GetOfferingCategoriesDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetOfferingCategoriesKey = "GetOfferingCategories";
export const UseGetOfferingCategoriesKeyFn = (
  clientOptions: Options<GetOfferingCategoriesData, true>,
  queryKey?: Array<unknown>
) => [useGetOfferingCategoriesKey, ...(queryKey ?? [clientOptions])];
export type GetOfferingsDefaultResponse = Awaited<
  ReturnType<typeof getOfferings>
>["data"];
export type GetOfferingsQueryResult<
  TData = GetOfferingsDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetOfferingsKey = "GetOfferings";
export const UseGetOfferingsKeyFn = (
  clientOptions: Options<GetOfferingsData, true>,
  queryKey?: Array<unknown>
) => [useGetOfferingsKey, ...(queryKey ?? [clientOptions])];
export type GetBoundaryConnectionsBySchoolIdDefaultResponse = Awaited<
  ReturnType<typeof getBoundaryConnectionsBySchoolId>
>["data"];
export type GetBoundaryConnectionsBySchoolIdQueryResult<
  TData = GetBoundaryConnectionsBySchoolIdDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetBoundaryConnectionsBySchoolIdKey =
  "GetBoundaryConnectionsBySchoolId";
export const UseGetBoundaryConnectionsBySchoolIdKeyFn = (
  clientOptions: Options<GetBoundaryConnectionsBySchoolIdData, true>,
  queryKey?: Array<unknown>
) => [useGetBoundaryConnectionsBySchoolIdKey, ...(queryKey ?? [clientOptions])];
export type GetBoundariesDefaultResponse = Awaited<
  ReturnType<typeof getBoundaries>
>["data"];
export type GetBoundariesQueryResult<
  TData = GetBoundariesDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetBoundariesKey = "GetBoundaries";
export const UseGetBoundariesKeyFn = (
  clientOptions: Options<GetBoundariesData, true> = {},
  queryKey?: Array<unknown>
) => [useGetBoundariesKey, ...(queryKey ?? [clientOptions])];
export type GetBoundariesMetadataDefaultResponse = Awaited<
  ReturnType<typeof getBoundariesMetadata>
>["data"];
export type GetBoundariesMetadataQueryResult<
  TData = GetBoundariesMetadataDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetBoundariesMetadataKey = "GetBoundariesMetadata";
export const UseGetBoundariesMetadataKeyFn = (
  clientOptions: Options<GetBoundariesMetadataData, true>,
  queryKey?: Array<unknown>
) => [useGetBoundariesMetadataKey, ...(queryKey ?? [clientOptions])];
export type GetBoundariesByOrgIdDefaultResponse = Awaited<
  ReturnType<typeof getBoundariesByOrgId>
>["data"];
export type GetBoundariesByOrgIdQueryResult<
  TData = GetBoundariesByOrgIdDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetBoundariesByOrgIdKey = "GetBoundariesByOrgId";
export const UseGetBoundariesByOrgIdKeyFn = (
  clientOptions: Options<GetBoundariesByOrgIdData, true>,
  queryKey?: Array<unknown>
) => [useGetBoundariesByOrgIdKey, ...(queryKey ?? [clientOptions])];
export type ExportBoundaryGeoJsonDefaultResponse = Awaited<
  ReturnType<typeof exportBoundaryGeoJson>
>["data"];
export type ExportBoundaryGeoJsonQueryResult<
  TData = ExportBoundaryGeoJsonDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useExportBoundaryGeoJsonKey = "ExportBoundaryGeoJson";
export const UseExportBoundaryGeoJsonKeyFn = (
  clientOptions: Options<ExportBoundaryGeoJsonData, true>,
  queryKey?: Array<unknown>
) => [useExportBoundaryGeoJsonKey, ...(queryKey ?? [clientOptions])];
export type ExportBoundariesByOrgGeoJsonDefaultResponse = Awaited<
  ReturnType<typeof exportBoundariesByOrgGeoJson>
>["data"];
export type ExportBoundariesByOrgGeoJsonQueryResult<
  TData = ExportBoundariesByOrgGeoJsonDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useExportBoundariesByOrgGeoJsonKey =
  "ExportBoundariesByOrgGeoJson";
export const UseExportBoundariesByOrgGeoJsonKeyFn = (
  clientOptions: Options<ExportBoundariesByOrgGeoJsonData, true>,
  queryKey?: Array<unknown>
) => [useExportBoundariesByOrgGeoJsonKey, ...(queryKey ?? [clientOptions])];
export type GetBoundaryMapByFormIdDefaultResponse = Awaited<
  ReturnType<typeof getBoundaryMapByFormId>
>["data"];
export type GetBoundaryMapByFormIdQueryResult<
  TData = GetBoundaryMapByFormIdDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetBoundaryMapByFormIdKey = "GetBoundaryMapByFormId";
export const UseGetBoundaryMapByFormIdKeyFn = (
  clientOptions: Options<GetBoundaryMapByFormIdData, true>,
  queryKey?: Array<unknown>
) => [useGetBoundaryMapByFormIdKey, ...(queryKey ?? [clientOptions])];
export type GetBoundaryMapByEnrollmentPeriodIdDefaultResponse = Awaited<
  ReturnType<typeof getBoundaryMapByEnrollmentPeriodId>
>["data"];
export type GetBoundaryMapByEnrollmentPeriodIdQueryResult<
  TData = GetBoundaryMapByEnrollmentPeriodIdDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetBoundaryMapByEnrollmentPeriodIdKey =
  "GetBoundaryMapByEnrollmentPeriodId";
export const UseGetBoundaryMapByEnrollmentPeriodIdKeyFn = (
  clientOptions: Options<GetBoundaryMapByEnrollmentPeriodIdData, true>,
  queryKey?: Array<unknown>
) => [
  useGetBoundaryMapByEnrollmentPeriodIdKey,
  ...(queryKey ?? [clientOptions]),
];
export type GetBoundaryMapByFormIdOptimizedDefaultResponse = Awaited<
  ReturnType<typeof getBoundaryMapByFormIdOptimized>
>["data"];
export type GetBoundaryMapByFormIdOptimizedQueryResult<
  TData = GetBoundaryMapByFormIdOptimizedDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetBoundaryMapByFormIdOptimizedKey =
  "GetBoundaryMapByFormIdOptimized";
export const UseGetBoundaryMapByFormIdOptimizedKeyFn = (
  clientOptions: Options<GetBoundaryMapByFormIdOptimizedData, true>,
  queryKey?: Array<unknown>
) => [useGetBoundaryMapByFormIdOptimizedKey, ...(queryKey ?? [clientOptions])];
export type GetBoundaryMapByEnrollmentPeriodIdOptimizedDefaultResponse =
  Awaited<
    ReturnType<typeof getBoundaryMapByEnrollmentPeriodIdOptimized>
  >["data"];
export type GetBoundaryMapByEnrollmentPeriodIdOptimizedQueryResult<
  TData = GetBoundaryMapByEnrollmentPeriodIdOptimizedDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetBoundaryMapByEnrollmentPeriodIdOptimizedKey =
  "GetBoundaryMapByEnrollmentPeriodIdOptimized";
export const UseGetBoundaryMapByEnrollmentPeriodIdOptimizedKeyFn = (
  clientOptions: Options<GetBoundaryMapByEnrollmentPeriodIdOptimizedData, true>,
  queryKey?: Array<unknown>
) => [
  useGetBoundaryMapByEnrollmentPeriodIdOptimizedKey,
  ...(queryKey ?? [clientOptions]),
];
export type GetCapacitiesBySchoolAndEnrollmentPeriodDefaultResponse = Awaited<
  ReturnType<typeof getCapacitiesBySchoolAndEnrollmentPeriod>
>["data"];
export type GetCapacitiesBySchoolAndEnrollmentPeriodQueryResult<
  TData = GetCapacitiesBySchoolAndEnrollmentPeriodDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetCapacitiesBySchoolAndEnrollmentPeriodKey =
  "GetCapacitiesBySchoolAndEnrollmentPeriod";
export const UseGetCapacitiesBySchoolAndEnrollmentPeriodKeyFn = (
  clientOptions: Options<GetCapacitiesBySchoolAndEnrollmentPeriodData, true>,
  queryKey?: Array<unknown>
) => [
  useGetCapacitiesBySchoolAndEnrollmentPeriodKey,
  ...(queryKey ?? [clientOptions]),
];
export type ListCapacitiesBySchoolAndEnrollmentPeriodDefaultResponse = Awaited<
  ReturnType<typeof listCapacitiesBySchoolAndEnrollmentPeriod>
>["data"];
export type ListCapacitiesBySchoolAndEnrollmentPeriodQueryResult<
  TData = ListCapacitiesBySchoolAndEnrollmentPeriodDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useListCapacitiesBySchoolAndEnrollmentPeriodKey =
  "ListCapacitiesBySchoolAndEnrollmentPeriod";
export const UseListCapacitiesBySchoolAndEnrollmentPeriodKeyFn = (
  clientOptions: Options<ListCapacitiesBySchoolAndEnrollmentPeriodData, true>,
  queryKey?: Array<unknown>
) => [
  useListCapacitiesBySchoolAndEnrollmentPeriodKey,
  ...(queryKey ?? [clientOptions]),
];
export type ListCapacitiesByEnrollmentPeriodDefaultResponse = Awaited<
  ReturnType<typeof listCapacitiesByEnrollmentPeriod>
>["data"];
export type ListCapacitiesByEnrollmentPeriodQueryResult<
  TData = ListCapacitiesByEnrollmentPeriodDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useListCapacitiesByEnrollmentPeriodKey =
  "ListCapacitiesByEnrollmentPeriod";
export const UseListCapacitiesByEnrollmentPeriodKeyFn = (
  clientOptions: Options<ListCapacitiesByEnrollmentPeriodData, true>,
  queryKey?: Array<unknown>
) => [useListCapacitiesByEnrollmentPeriodKey, ...(queryKey ?? [clientOptions])];
export type GetCapacitiesConfigByEnrollmentPeriodDefaultResponse = Awaited<
  ReturnType<typeof getCapacitiesConfigByEnrollmentPeriod>
>["data"];
export type GetCapacitiesConfigByEnrollmentPeriodQueryResult<
  TData = GetCapacitiesConfigByEnrollmentPeriodDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetCapacitiesConfigByEnrollmentPeriodKey =
  "GetCapacitiesConfigByEnrollmentPeriod";
export const UseGetCapacitiesConfigByEnrollmentPeriodKeyFn = (
  clientOptions: Options<GetCapacitiesConfigByEnrollmentPeriodData, true>,
  queryKey?: Array<unknown>
) => [
  useGetCapacitiesConfigByEnrollmentPeriodKey,
  ...(queryKey ?? [clientOptions]),
];
export type GetCapacitySummaryByEnrollmentPeriodDefaultResponse = Awaited<
  ReturnType<typeof getCapacitySummaryByEnrollmentPeriod>
>["data"];
export type GetCapacitySummaryByEnrollmentPeriodQueryResult<
  TData = GetCapacitySummaryByEnrollmentPeriodDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetCapacitySummaryByEnrollmentPeriodKey =
  "GetCapacitySummaryByEnrollmentPeriod";
export const UseGetCapacitySummaryByEnrollmentPeriodKeyFn = (
  clientOptions: Options<GetCapacitySummaryByEnrollmentPeriodData, true>,
  queryKey?: Array<unknown>
) => [
  useGetCapacitySummaryByEnrollmentPeriodKey,
  ...(queryKey ?? [clientOptions]),
];
export type GetCapacitiesHistoryDefaultResponse = Awaited<
  ReturnType<typeof getCapacitiesHistory>
>["data"];
export type GetCapacitiesHistoryQueryResult<
  TData = GetCapacitiesHistoryDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetCapacitiesHistoryKey = "GetCapacitiesHistory";
export const UseGetCapacitiesHistoryKeyFn = (
  clientOptions: Options<GetCapacitiesHistoryData, true>,
  queryKey?: Array<unknown>
) => [useGetCapacitiesHistoryKey, ...(queryKey ?? [clientOptions])];
export type GetCapacitiesHistoryDetailDefaultResponse = Awaited<
  ReturnType<typeof getCapacitiesHistoryDetail>
>["data"];
export type GetCapacitiesHistoryDetailQueryResult<
  TData = GetCapacitiesHistoryDetailDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetCapacitiesHistoryDetailKey = "GetCapacitiesHistoryDetail";
export const UseGetCapacitiesHistoryDetailKeyFn = (
  clientOptions: Options<GetCapacitiesHistoryDetailData, true>,
  queryKey?: Array<unknown>
) => [useGetCapacitiesHistoryDetailKey, ...(queryKey ?? [clientOptions])];
export type GetSchoolsDefaultResponse = Awaited<
  ReturnType<typeof getSchools>
>["data"];
export type GetSchoolsQueryResult<
  TData = GetSchoolsDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetSchoolsKey = "GetSchools";
export const UseGetSchoolsKeyFn = (
  clientOptions: Options<GetSchoolsData, true>,
  queryKey?: Array<unknown>
) => [useGetSchoolsKey, ...(queryKey ?? [clientOptions])];
export type GetSchoolsByEnrollmentPeriodDefaultResponse = Awaited<
  ReturnType<typeof getSchoolsByEnrollmentPeriod>
>["data"];
export type GetSchoolsByEnrollmentPeriodQueryResult<
  TData = GetSchoolsByEnrollmentPeriodDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetSchoolsByEnrollmentPeriodKey =
  "GetSchoolsByEnrollmentPeriod";
export const UseGetSchoolsByEnrollmentPeriodKeyFn = (
  clientOptions: Options<GetSchoolsByEnrollmentPeriodData, true>,
  queryKey?: Array<unknown>
) => [useGetSchoolsByEnrollmentPeriodKey, ...(queryKey ?? [clientOptions])];
export type GetDashboardFormStatusDefaultResponse = Awaited<
  ReturnType<typeof getDashboardFormStatus>
>["data"];
export type GetDashboardFormStatusQueryResult<
  TData = GetDashboardFormStatusDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetDashboardFormStatusKey = "GetDashboardFormStatus";
export const UseGetDashboardFormStatusKeyFn = (
  clientOptions: Options<GetDashboardFormStatusData, true>,
  queryKey?: Array<unknown>
) => [useGetDashboardFormStatusKey, ...(queryKey ?? [clientOptions])];
export type GetDashboardFormSubstatusDefaultResponse = Awaited<
  ReturnType<typeof getDashboardFormSubstatus>
>["data"];
export type GetDashboardFormSubstatusQueryResult<
  TData = GetDashboardFormSubstatusDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetDashboardFormSubstatusKey = "GetDashboardFormSubstatus";
export const UseGetDashboardFormSubstatusKeyFn = (
  clientOptions: Options<GetDashboardFormSubstatusData, true>,
  queryKey?: Array<unknown>
) => [useGetDashboardFormSubstatusKey, ...(queryKey ?? [clientOptions])];
export type GetDashboardFormSchoolGradeRankDefaultResponse = Awaited<
  ReturnType<typeof getDashboardFormSchoolGradeRank>
>["data"];
export type GetDashboardFormSchoolGradeRankQueryResult<
  TData = GetDashboardFormSchoolGradeRankDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetDashboardFormSchoolGradeRankKey =
  "GetDashboardFormSchoolGradeRank";
export const UseGetDashboardFormSchoolGradeRankKeyFn = (
  clientOptions: Options<GetDashboardFormSchoolGradeRankData, true>,
  queryKey?: Array<unknown>
) => [useGetDashboardFormSchoolGradeRankKey, ...(queryKey ?? [clientOptions])];
export type GetDashboardFormResponsesOverTimeDefaultResponse = Awaited<
  ReturnType<typeof getDashboardFormResponsesOverTime>
>["data"];
export type GetDashboardFormResponsesOverTimeQueryResult<
  TData = GetDashboardFormResponsesOverTimeDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetDashboardFormResponsesOverTimeKey =
  "GetDashboardFormResponsesOverTime";
export const UseGetDashboardFormResponsesOverTimeKeyFn = (
  clientOptions: Options<GetDashboardFormResponsesOverTimeData, true>,
  queryKey?: Array<unknown>
) => [
  useGetDashboardFormResponsesOverTimeKey,
  ...(queryKey ?? [clientOptions]),
];
export type GetAdminGreetingDefaultResponse = Awaited<
  ReturnType<typeof getAdminGreeting>
>["data"];
export type GetAdminGreetingQueryResult<
  TData = GetAdminGreetingDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetAdminGreetingKey = "GetAdminGreeting";
export const UseGetAdminGreetingKeyFn = (
  clientOptions: Options<GetAdminGreetingData, true>,
  queryKey?: Array<unknown>
) => [useGetAdminGreetingKey, ...(queryKey ?? [clientOptions])];
export type GetGradeConfigByEnrollmentPeriodDefaultResponse = Awaited<
  ReturnType<typeof getGradeConfigByEnrollmentPeriod>
>["data"];
export type GetGradeConfigByEnrollmentPeriodQueryResult<
  TData = GetGradeConfigByEnrollmentPeriodDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetGradeConfigByEnrollmentPeriodKey =
  "GetGradeConfigByEnrollmentPeriod";
export const UseGetGradeConfigByEnrollmentPeriodKeyFn = (
  clientOptions: Options<GetGradeConfigByEnrollmentPeriodData, true>,
  queryKey?: Array<unknown>
) => [useGetGradeConfigByEnrollmentPeriodKey, ...(queryKey ?? [clientOptions])];
export type SearchApplicantsDefaultResponse = Awaited<
  ReturnType<typeof searchApplicants>
>["data"];
export type SearchApplicantsQueryResult<
  TData = SearchApplicantsDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useSearchApplicantsKey = "SearchApplicants";
export const UseSearchApplicantsKeyFn = (
  clientOptions: Options<SearchApplicantsData, true>,
  queryKey?: Array<unknown>
) => [useSearchApplicantsKey, ...(queryKey ?? [clientOptions])];
export type SearchApplicantDuplicatesDefaultResponse = Awaited<
  ReturnType<typeof searchApplicantDuplicates>
>["data"];
export type SearchApplicantDuplicatesQueryResult<
  TData = SearchApplicantDuplicatesDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useSearchApplicantDuplicatesKey = "SearchApplicantDuplicates";
export const UseSearchApplicantDuplicatesKeyFn = (
  clientOptions: Options<SearchApplicantDuplicatesData, true>,
  queryKey?: Array<unknown>
) => [useSearchApplicantDuplicatesKey, ...(queryKey ?? [clientOptions])];
export type SearchParentsDefaultResponse = Awaited<
  ReturnType<typeof searchParents>
>["data"];
export type SearchParentsQueryResult<
  TData = SearchParentsDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useSearchParentsKey = "SearchParents";
export const UseSearchParentsKeyFn = (
  clientOptions: Options<SearchParentsData, true>,
  queryKey?: Array<unknown>
) => [useSearchParentsKey, ...(queryKey ?? [clientOptions])];
export type ListMatchRunsDefaultResponse = Awaited<
  ReturnType<typeof listMatchRuns>
>["data"];
export type ListMatchRunsQueryResult<
  TData = ListMatchRunsDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useListMatchRunsKey = "ListMatchRuns";
export const UseListMatchRunsKeyFn = (
  clientOptions: Options<ListMatchRunsData, true>,
  queryKey?: Array<unknown>
) => [useListMatchRunsKey, ...(queryKey ?? [clientOptions])];
export type GetMatchRunDetailsDefaultResponse = Awaited<
  ReturnType<typeof getMatchRunDetails>
>["data"];
export type GetMatchRunDetailsQueryResult<
  TData = GetMatchRunDetailsDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetMatchRunDetailsKey = "GetMatchRunDetails";
export const UseGetMatchRunDetailsKeyFn = (
  clientOptions: Options<GetMatchRunDetailsData, true>,
  queryKey?: Array<unknown>
) => [useGetMatchRunDetailsKey, ...(queryKey ?? [clientOptions])];
export type GetMatchRunDefaultResponse = Awaited<
  ReturnType<typeof getMatchRun>
>["data"];
export type GetMatchRunQueryResult<
  TData = GetMatchRunDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetMatchRunKey = "GetMatchRun";
export const UseGetMatchRunKeyFn = (
  clientOptions: Options<GetMatchRunData, true>,
  queryKey?: Array<unknown>
) => [useGetMatchRunKey, ...(queryKey ?? [clientOptions])];
export type GetFormAlertsByFormIdDefaultResponse = Awaited<
  ReturnType<typeof getFormAlertsByFormId>
>["data"];
export type GetFormAlertsByFormIdQueryResult<
  TData = GetFormAlertsByFormIdDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetFormAlertsByFormIdKey = "GetFormAlertsByFormId";
export const UseGetFormAlertsByFormIdKeyFn = (
  clientOptions: Options<GetFormAlertsByFormIdData, true>,
  queryKey?: Array<unknown>
) => [useGetFormAlertsByFormIdKey, ...(queryKey ?? [clientOptions])];
export type ListUserGroupsDefaultResponse = Awaited<
  ReturnType<typeof listUserGroups>
>["data"];
export type ListUserGroupsQueryResult<
  TData = ListUserGroupsDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useListUserGroupsKey = "ListUserGroups";
export const UseListUserGroupsKeyFn = (
  clientOptions: Options<unknown, true> = {},
  queryKey?: Array<unknown>
) => [useListUserGroupsKey, ...(queryKey ?? [clientOptions])];
export type ListTeamsDefaultResponse = Awaited<
  ReturnType<typeof listTeams>
>["data"];
export type ListTeamsQueryResult<
  TData = ListTeamsDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useListTeamsKey = "ListTeams";
export const UseListTeamsKeyFn = (
  clientOptions: Options<ListTeamsData, true>,
  queryKey?: Array<unknown>
) => [useListTeamsKey, ...(queryKey ?? [clientOptions])];
export type ListApiCredentialsDefaultResponse = Awaited<
  ReturnType<typeof listApiCredentials>
>["data"];
export type ListApiCredentialsQueryResult<
  TData = ListApiCredentialsDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useListApiCredentialsKey = "ListApiCredentials";
export const UseListApiCredentialsKeyFn = (
  clientOptions: Options<ListApiCredentialsData, true>,
  queryKey?: Array<unknown>
) => [useListApiCredentialsKey, ...(queryKey ?? [clientOptions])];
export type GetApiCredentialDefaultResponse = Awaited<
  ReturnType<typeof getApiCredential>
>["data"];
export type GetApiCredentialQueryResult<
  TData = GetApiCredentialDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetApiCredentialKey = "GetApiCredential";
export const UseGetApiCredentialKeyFn = (
  clientOptions: Options<GetApiCredentialData, true>,
  queryKey?: Array<unknown>
) => [useGetApiCredentialKey, ...(queryKey ?? [clientOptions])];
export type GetOrganizationConfigDefaultResponse = Awaited<
  ReturnType<typeof getOrganizationConfig>
>["data"];
export type GetOrganizationConfigQueryResult<
  TData = GetOrganizationConfigDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetOrganizationConfigKey = "GetOrganizationConfig";
export const UseGetOrganizationConfigKeyFn = (
  clientOptions: Options<GetOrganizationConfigData, true>,
  queryKey?: Array<unknown>
) => [useGetOrganizationConfigKey, ...(queryKey ?? [clientOptions])];
export type ListPaymentTemplatesDefaultResponse = Awaited<
  ReturnType<typeof listPaymentTemplates>
>["data"];
export type ListPaymentTemplatesQueryResult<
  TData = ListPaymentTemplatesDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useListPaymentTemplatesKey = "ListPaymentTemplates";
export const UseListPaymentTemplatesKeyFn = (
  clientOptions: Options<ListPaymentTemplatesData, true>,
  queryKey?: Array<unknown>
) => [useListPaymentTemplatesKey, ...(queryKey ?? [clientOptions])];
export type GetPaymentTemplateDefaultResponse = Awaited<
  ReturnType<typeof getPaymentTemplate>
>["data"];
export type GetPaymentTemplateQueryResult<
  TData = GetPaymentTemplateDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetPaymentTemplateKey = "GetPaymentTemplate";
export const UseGetPaymentTemplateKeyFn = (
  clientOptions: Options<GetPaymentTemplateData, true>,
  queryKey?: Array<unknown>
) => [useGetPaymentTemplateKey, ...(queryKey ?? [clientOptions])];
export type ListPaymentsDefaultResponse = Awaited<
  ReturnType<typeof listPayments>
>["data"];
export type ListPaymentsQueryResult<
  TData = ListPaymentsDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useListPaymentsKey = "ListPayments";
export const UseListPaymentsKeyFn = (
  clientOptions: Options<ListPaymentsData, true>,
  queryKey?: Array<unknown>
) => [useListPaymentsKey, ...(queryKey ?? [clientOptions])];
export type GetAdminPaymentReceiptDefaultResponse = Awaited<
  ReturnType<typeof getAdminPaymentReceipt>
>["data"];
export type GetAdminPaymentReceiptQueryResult<
  TData = GetAdminPaymentReceiptDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetAdminPaymentReceiptKey = "GetAdminPaymentReceipt";
export const UseGetAdminPaymentReceiptKeyFn = (
  clientOptions: Options<GetAdminPaymentReceiptData, true>,
  queryKey?: Array<unknown>
) => [useGetAdminPaymentReceiptKey, ...(queryKey ?? [clientOptions])];
export type GetAdmissionsForMeDefaultResponse = Awaited<
  ReturnType<typeof getAdmissionsForMe>
>["data"];
export type GetAdmissionsForMeQueryResult<
  TData = GetAdmissionsForMeDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetAdmissionsForMeKey = "GetAdmissionsForMe";
export const UseGetAdmissionsForMeKeyFn = (
  clientOptions: Options<GetAdmissionsForMeData, true>,
  queryKey?: Array<unknown>
) => [useGetAdmissionsForMeKey, ...(queryKey ?? [clientOptions])];
export type GetOffersForMeDefaultResponse = Awaited<
  ReturnType<typeof getOffersForMe>
>["data"];
export type GetOffersForMeQueryResult<
  TData = GetOffersForMeDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetOffersForMeKey = "GetOffersForMe";
export const UseGetOffersForMeKeyFn = (
  clientOptions: Options<GetOffersForMeData, true>,
  queryKey?: Array<unknown>
) => [useGetOffersForMeKey, ...(queryKey ?? [clientOptions])];
export type GetAnswersForMeDefaultResponse = Awaited<
  ReturnType<typeof getAnswersForMe>
>["data"];
export type GetAnswersForMeQueryResult<
  TData = GetAnswersForMeDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetAnswersForMeKey = "GetAnswersForMe";
export const UseGetAnswersForMeKeyFn = (
  clientOptions: Options<GetAnswersForMeData, true>,
  queryKey?: Array<unknown>
) => [useGetAnswersForMeKey, ...(queryKey ?? [clientOptions])];
export type GetEligibleFormTemplatesForMeDefaultResponse = Awaited<
  ReturnType<typeof getEligibleFormTemplatesForMe>
>["data"];
export type GetEligibleFormTemplatesForMeQueryResult<
  TData = GetEligibleFormTemplatesForMeDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetEligibleFormTemplatesForMeKey =
  "GetEligibleFormTemplatesForMe";
export const UseGetEligibleFormTemplatesForMeKeyFn = (
  clientOptions: Options<GetEligibleFormTemplatesForMeData, true>,
  queryKey?: Array<unknown>
) => [useGetEligibleFormTemplatesForMeKey, ...(queryKey ?? [clientOptions])];
export type GetFormTemplateSettingsForMeDefaultResponse = Awaited<
  ReturnType<typeof getFormTemplateSettingsForMe>
>["data"];
export type GetFormTemplateSettingsForMeQueryResult<
  TData = GetFormTemplateSettingsForMeDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetFormTemplateSettingsForMeKey =
  "GetFormTemplateSettingsForMe";
export const UseGetFormTemplateSettingsForMeKeyFn = (
  clientOptions: Options<GetFormTemplateSettingsForMeData, true>,
  queryKey?: Array<unknown>
) => [useGetFormTemplateSettingsForMeKey, ...(queryKey ?? [clientOptions])];
export type ParentGetBoundaryMapByFormIdDefaultResponse = Awaited<
  ReturnType<typeof parentGetBoundaryMapByFormId>
>["data"];
export type ParentGetBoundaryMapByFormIdQueryResult<
  TData = ParentGetBoundaryMapByFormIdDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useParentGetBoundaryMapByFormIdKey =
  "ParentGetBoundaryMapByFormId";
export const UseParentGetBoundaryMapByFormIdKeyFn = (
  clientOptions: Options<ParentGetBoundaryMapByFormIdData, true>,
  queryKey?: Array<unknown>
) => [useParentGetBoundaryMapByFormIdKey, ...(queryKey ?? [clientOptions])];
export type ParentGetBoundaryMapByEnrollmentPeriodIdDefaultResponse = Awaited<
  ReturnType<typeof parentGetBoundaryMapByEnrollmentPeriodId>
>["data"];
export type ParentGetBoundaryMapByEnrollmentPeriodIdQueryResult<
  TData = ParentGetBoundaryMapByEnrollmentPeriodIdDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useParentGetBoundaryMapByEnrollmentPeriodIdKey =
  "ParentGetBoundaryMapByEnrollmentPeriodId";
export const UseParentGetBoundaryMapByEnrollmentPeriodIdKeyFn = (
  clientOptions: Options<ParentGetBoundaryMapByEnrollmentPeriodIdData, true>,
  queryKey?: Array<unknown>
) => [
  useParentGetBoundaryMapByEnrollmentPeriodIdKey,
  ...(queryKey ?? [clientOptions]),
];
export type ParentGetBoundaryMapByFormIdOptimizedDefaultResponse = Awaited<
  ReturnType<typeof parentGetBoundaryMapByFormIdOptimized>
>["data"];
export type ParentGetBoundaryMapByFormIdOptimizedQueryResult<
  TData = ParentGetBoundaryMapByFormIdOptimizedDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useParentGetBoundaryMapByFormIdOptimizedKey =
  "ParentGetBoundaryMapByFormIdOptimized";
export const UseParentGetBoundaryMapByFormIdOptimizedKeyFn = (
  clientOptions: Options<ParentGetBoundaryMapByFormIdOptimizedData, true>,
  queryKey?: Array<unknown>
) => [
  useParentGetBoundaryMapByFormIdOptimizedKey,
  ...(queryKey ?? [clientOptions]),
];
export type ParentGetBoundaryMapByEnrollmentPeriodIdOptimizedDefaultResponse =
  Awaited<
    ReturnType<typeof parentGetBoundaryMapByEnrollmentPeriodIdOptimized>
  >["data"];
export type ParentGetBoundaryMapByEnrollmentPeriodIdOptimizedQueryResult<
  TData = ParentGetBoundaryMapByEnrollmentPeriodIdOptimizedDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useParentGetBoundaryMapByEnrollmentPeriodIdOptimizedKey =
  "ParentGetBoundaryMapByEnrollmentPeriodIdOptimized";
export const UseParentGetBoundaryMapByEnrollmentPeriodIdOptimizedKeyFn = (
  clientOptions: Options<
    ParentGetBoundaryMapByEnrollmentPeriodIdOptimizedData,
    true
  >,
  queryKey?: Array<unknown>
) => [
  useParentGetBoundaryMapByEnrollmentPeriodIdOptimizedKey,
  ...(queryKey ?? [clientOptions]),
];
export type GetPaymentsForMeDefaultResponse = Awaited<
  ReturnType<typeof getPaymentsForMe>
>["data"];
export type GetPaymentsForMeQueryResult<
  TData = GetPaymentsForMeDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetPaymentsForMeKey = "GetPaymentsForMe";
export const UseGetPaymentsForMeKeyFn = (
  clientOptions: Options<GetPaymentsForMeData, true>,
  queryKey?: Array<unknown>
) => [useGetPaymentsForMeKey, ...(queryKey ?? [clientOptions])];
export type GetPaymentReceiptDefaultResponse = Awaited<
  ReturnType<typeof getPaymentReceipt>
>["data"];
export type GetPaymentReceiptQueryResult<
  TData = GetPaymentReceiptDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>;
export const useGetPaymentReceiptKey = "GetPaymentReceipt";
export const UseGetPaymentReceiptKeyFn = (
  clientOptions: Options<GetPaymentReceiptData, true> = {},
  queryKey?: Array<unknown>
) => [useGetPaymentReceiptKey, ...(queryKey ?? [clientOptions])];
export type CreateFormForAdminMutationResult = Awaited<
  ReturnType<typeof createFormForAdmin>
>;
export const useCreateFormForAdminKey = "CreateFormForAdmin";
export const UseCreateFormForAdminKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateFormForAdminKey,
  ...(mutationKey ?? []),
];
export type CheckEligibilityMutationResult = Awaited<
  ReturnType<typeof checkEligibility>
>;
export const useCheckEligibilityKey = "CheckEligibility";
export const UseCheckEligibilityKeyFn = (mutationKey?: Array<unknown>) => [
  useCheckEligibilityKey,
  ...(mutationKey ?? []),
];
export type AddSchoolToFormMutationResult = Awaited<
  ReturnType<typeof addSchoolToForm>
>;
export const useAddSchoolToFormKey = "AddSchoolToForm";
export const UseAddSchoolToFormKeyFn = (mutationKey?: Array<unknown>) => [
  useAddSchoolToFormKey,
  ...(mutationKey ?? []),
];
export type GetFormsMutationResult = Awaited<ReturnType<typeof getForms>>;
export const useGetFormsKey = "GetForms";
export const UseGetFormsKeyFn = (mutationKey?: Array<unknown>) => [
  useGetFormsKey,
  ...(mutationKey ?? []),
];
export type CreateBulkFormActionMutationResult = Awaited<
  ReturnType<typeof createBulkFormAction>
>;
export const useCreateBulkFormActionKey = "CreateBulkFormAction";
export const UseCreateBulkFormActionKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateBulkFormActionKey,
  ...(mutationKey ?? []),
];
export type GeocodeAnswerMutationResult = Awaited<
  ReturnType<typeof geocodeAnswer>
>;
export const useGeocodeAnswerKey = "GeocodeAnswer";
export const UseGeocodeAnswerKeyFn = (mutationKey?: Array<unknown>) => [
  useGeocodeAnswerKey,
  ...(mutationKey ?? []),
];
export type BulkMakeOffersMutationResult = Awaited<
  ReturnType<typeof bulkMakeOffers>
>;
export const useBulkMakeOffersKey = "BulkMakeOffers";
export const UseBulkMakeOffersKeyFn = (mutationKey?: Array<unknown>) => [
  useBulkMakeOffersKey,
  ...(mutationKey ?? []),
];
export type BulkGetOfferExpirationInfoMutationResult = Awaited<
  ReturnType<typeof bulkGetOfferExpirationInfo>
>;
export const useBulkGetOfferExpirationInfoKey = "BulkGetOfferExpirationInfo";
export const UseBulkGetOfferExpirationInfoKeyFn = (
  mutationKey?: Array<unknown>
) => [useBulkGetOfferExpirationInfoKey, ...(mutationKey ?? [])];
export type CreateBulkOfferActionMutationResult = Awaited<
  ReturnType<typeof createBulkOfferAction>
>;
export const useCreateBulkOfferActionKey = "CreateBulkOfferAction";
export const UseCreateBulkOfferActionKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateBulkOfferActionKey,
  ...(mutationKey ?? []),
];
export type CreateOfferConfigurationMutationResult = Awaited<
  ReturnType<typeof createOfferConfiguration>
>;
export const useCreateOfferConfigurationKey = "CreateOfferConfiguration";
export const UseCreateOfferConfigurationKeyFn = (
  mutationKey?: Array<unknown>
) => [useCreateOfferConfigurationKey, ...(mutationKey ?? [])];
export type PostWaitlistsMutationResult = Awaited<
  ReturnType<typeof postWaitlists>
>;
export const usePostWaitlistsKey = "PostWaitlists";
export const UsePostWaitlistsKeyFn = (mutationKey?: Array<unknown>) => [
  usePostWaitlistsKey,
  ...(mutationKey ?? []),
];
export type CreateBulkWaitlistActionMutationResult = Awaited<
  ReturnType<typeof createBulkWaitlistAction>
>;
export const useCreateBulkWaitlistActionKey = "CreateBulkWaitlistAction";
export const UseCreateBulkWaitlistActionKeyFn = (
  mutationKey?: Array<unknown>
) => [useCreateBulkWaitlistActionKey, ...(mutationKey ?? [])];
export type CreateBulkSubstatusActionMutationResult = Awaited<
  ReturnType<typeof createBulkSubstatusAction>
>;
export const useCreateBulkSubstatusActionKey = "CreateBulkSubstatusAction";
export const UseCreateBulkSubstatusActionKeyFn = (
  mutationKey?: Array<unknown>
) => [useCreateBulkSubstatusActionKey, ...(mutationKey ?? [])];
export type ListAllowedSubStatusTransitionsMutationResult = Awaited<
  ReturnType<typeof listAllowedSubStatusTransitions>
>;
export const useListAllowedSubStatusTransitionsKey =
  "ListAllowedSubStatusTransitions";
export const UseListAllowedSubStatusTransitionsKeyFn = (
  mutationKey?: Array<unknown>
) => [useListAllowedSubStatusTransitionsKey, ...(mutationKey ?? [])];
export type GeocodeFormsMutationResult = Awaited<
  ReturnType<typeof geocodeForms>
>;
export const useGeocodeFormsKey = "GeocodeForms";
export const UseGeocodeFormsKeyFn = (mutationKey?: Array<unknown>) => [
  useGeocodeFormsKey,
  ...(mutationKey ?? []),
];
export type ListFormsAdvancedMutationResult = Awaited<
  ReturnType<typeof listFormsAdvanced>
>;
export const useListFormsAdvancedKey = "ListFormsAdvanced";
export const UseListFormsAdvancedKeyFn = (mutationKey?: Array<unknown>) => [
  useListFormsAdvancedKey,
  ...(mutationKey ?? []),
];
export type ListFormsFromSelectionMutationResult = Awaited<
  ReturnType<typeof listFormsFromSelection>
>;
export const useListFormsFromSelectionKey = "ListFormsFromSelection";
export const UseListFormsFromSelectionKeyFn = (
  mutationKey?: Array<unknown>
) => [useListFormsFromSelectionKey, ...(mutationKey ?? [])];
export type ListFormIdsAdvancedMutationResult = Awaited<
  ReturnType<typeof listFormIdsAdvanced>
>;
export const useListFormIdsAdvancedKey = "ListFormIdsAdvanced";
export const UseListFormIdsAdvancedKeyFn = (mutationKey?: Array<unknown>) => [
  useListFormIdsAdvancedKey,
  ...(mutationKey ?? []),
];
export type ListFormIdsAdvancedV2MutationResult = Awaited<
  ReturnType<typeof listFormIdsAdvancedV2>
>;
export const useListFormIdsAdvancedV2Key = "ListFormIdsAdvancedV2";
export const UseListFormIdsAdvancedV2KeyFn = (mutationKey?: Array<unknown>) => [
  useListFormIdsAdvancedV2Key,
  ...(mutationKey ?? []),
];
export type AddFormTagMutationResult = Awaited<ReturnType<typeof addFormTag>>;
export const useAddFormTagKey = "AddFormTag";
export const UseAddFormTagKeyFn = (mutationKey?: Array<unknown>) => [
  useAddFormTagKey,
  ...(mutationKey ?? []),
];
export type CreateBulkFormTagActionMutationResult = Awaited<
  ReturnType<typeof createBulkFormTagAction>
>;
export const useCreateBulkFormTagActionKey = "CreateBulkFormTagAction";
export const UseCreateBulkFormTagActionKeyFn = (
  mutationKey?: Array<unknown>
) => [useCreateBulkFormTagActionKey, ...(mutationKey ?? [])];
export type AddFormSchoolTagMutationResult = Awaited<
  ReturnType<typeof addFormSchoolTag>
>;
export const useAddFormSchoolTagKey = "AddFormSchoolTag";
export const UseAddFormSchoolTagKeyFn = (mutationKey?: Array<unknown>) => [
  useAddFormSchoolTagKey,
  ...(mutationKey ?? []),
];
export type CreateTagGroupMutationResult = Awaited<
  ReturnType<typeof createTagGroup>
>;
export const useCreateTagGroupKey = "CreateTagGroup";
export const UseCreateTagGroupKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateTagGroupKey,
  ...(mutationKey ?? []),
];
export type CreateTagMutationResult = Awaited<ReturnType<typeof createTag>>;
export const useCreateTagKey = "CreateTag";
export const UseCreateTagKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateTagKey,
  ...(mutationKey ?? []),
];
export type CreateRuleExecutionsMutationResult = Awaited<
  ReturnType<typeof createRuleExecutions>
>;
export const useCreateRuleExecutionsKey = "CreateRuleExecutions";
export const UseCreateRuleExecutionsKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateRuleExecutionsKey,
  ...(mutationKey ?? []),
];
export type ImportRuleConfigurationMutationResult = Awaited<
  ReturnType<typeof importRuleConfiguration>
>;
export const useImportRuleConfigurationKey = "ImportRuleConfiguration";
export const UseImportRuleConfigurationKeyFn = (
  mutationKey?: Array<unknown>
) => [useImportRuleConfigurationKey, ...(mutationKey ?? [])];
export type CreateFormTemplateMutationResult = Awaited<
  ReturnType<typeof createFormTemplate>
>;
export const useCreateFormTemplateKey = "CreateFormTemplate";
export const UseCreateFormTemplateKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateFormTemplateKey,
  ...(mutationKey ?? []),
];
export type DiffFormSchemaMutationResult = Awaited<
  ReturnType<typeof diffFormSchema>
>;
export const useDiffFormSchemaKey = "DiffFormSchema";
export const UseDiffFormSchemaKeyFn = (mutationKey?: Array<unknown>) => [
  useDiffFormSchemaKey,
  ...(mutationKey ?? []),
];
export type ValidateFormSchemaMutationResult = Awaited<
  ReturnType<typeof validateFormSchema>
>;
export const useValidateFormSchemaKey = "ValidateFormSchema";
export const UseValidateFormSchemaKeyFn = (mutationKey?: Array<unknown>) => [
  useValidateFormSchemaKey,
  ...(mutationKey ?? []),
];
export type PublishFormSchemaMutationResult = Awaited<
  ReturnType<typeof publishFormSchema>
>;
export const usePublishFormSchemaKey = "PublishFormSchema";
export const UsePublishFormSchemaKeyFn = (mutationKey?: Array<unknown>) => [
  usePublishFormSchemaKey,
  ...(mutationKey ?? []),
];
export type ImportFormTemplateFromJsonMutationResult = Awaited<
  ReturnType<typeof importFormTemplateFromJson>
>;
export const useImportFormTemplateFromJsonKey = "ImportFormTemplateFromJson";
export const UseImportFormTemplateFromJsonKeyFn = (
  mutationKey?: Array<unknown>
) => [useImportFormTemplateFromJsonKey, ...(mutationKey ?? [])];
export type ImportFormTemplateFromOtherMutationResult = Awaited<
  ReturnType<typeof importFormTemplateFromOther>
>;
export const useImportFormTemplateFromOtherKey = "ImportFormTemplateFromOther";
export const UseImportFormTemplateFromOtherKeyFn = (
  mutationKey?: Array<unknown>
) => [useImportFormTemplateFromOtherKey, ...(mutationKey ?? [])];
export type CreateFormRuleMutationResult = Awaited<
  ReturnType<typeof createFormRule>
>;
export const useCreateFormRuleKey = "CreateFormRule";
export const UseCreateFormRuleKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateFormRuleKey,
  ...(mutationKey ?? []),
];
export type ImportMessageTemplatesMutationResult = Awaited<
  ReturnType<typeof importMessageTemplates>
>;
export const useImportMessageTemplatesKey = "ImportMessageTemplates";
export const UseImportMessageTemplatesKeyFn = (
  mutationKey?: Array<unknown>
) => [useImportMessageTemplatesKey, ...(mutationKey ?? [])];
export type ImportMessageTemplatesFromOtherMutationResult = Awaited<
  ReturnType<typeof importMessageTemplatesFromOther>
>;
export const useImportMessageTemplatesFromOtherKey =
  "ImportMessageTemplatesFromOther";
export const UseImportMessageTemplatesFromOtherKeyFn = (
  mutationKey?: Array<unknown>
) => [useImportMessageTemplatesFromOtherKey, ...(mutationKey ?? [])];
export type ImportSchoolsAndGradesForEnrollmentPeriodMutationResult = Awaited<
  ReturnType<typeof importSchoolsAndGradesForEnrollmentPeriod>
>;
export const useImportSchoolsAndGradesForEnrollmentPeriodKey =
  "ImportSchoolsAndGradesForEnrollmentPeriod";
export const UseImportSchoolsAndGradesForEnrollmentPeriodKeyFn = (
  mutationKey?: Array<unknown>
) => [useImportSchoolsAndGradesForEnrollmentPeriodKey, ...(mutationKey ?? [])];
export type ImportSchoolsAndGradesFromOthersForEnrollmentPeriodMutationResult =
  Awaited<
    ReturnType<typeof importSchoolsAndGradesFromOthersForEnrollmentPeriod>
  >;
export const useImportSchoolsAndGradesFromOthersForEnrollmentPeriodKey =
  "ImportSchoolsAndGradesFromOthersForEnrollmentPeriod";
export const UseImportSchoolsAndGradesFromOthersForEnrollmentPeriodKeyFn = (
  mutationKey?: Array<unknown>
) => [
  useImportSchoolsAndGradesFromOthersForEnrollmentPeriodKey,
  ...(mutationKey ?? []),
];
export type ImportSchoolBoundaryConnectionsMutationResult = Awaited<
  ReturnType<typeof importSchoolBoundaryConnections>
>;
export const useImportSchoolBoundaryConnectionsKey =
  "ImportSchoolBoundaryConnections";
export const UseImportSchoolBoundaryConnectionsKeyFn = (
  mutationKey?: Array<unknown>
) => [useImportSchoolBoundaryConnectionsKey, ...(mutationKey ?? [])];
export type ImportBoundaryConnectionsFromEnrollmentPeriodMutationResult =
  Awaited<ReturnType<typeof importBoundaryConnectionsFromEnrollmentPeriod>>;
export const useImportBoundaryConnectionsFromEnrollmentPeriodKey =
  "ImportBoundaryConnectionsFromEnrollmentPeriod";
export const UseImportBoundaryConnectionsFromEnrollmentPeriodKeyFn = (
  mutationKey?: Array<unknown>
) => [
  useImportBoundaryConnectionsFromEnrollmentPeriodKey,
  ...(mutationKey ?? []),
];
export type CreateOfferingCategoriesMutationResult = Awaited<
  ReturnType<typeof createOfferingCategories>
>;
export const useCreateOfferingCategoriesKey = "CreateOfferingCategories";
export const UseCreateOfferingCategoriesKeyFn = (
  mutationKey?: Array<unknown>
) => [useCreateOfferingCategoriesKey, ...(mutationKey ?? [])];
export type CreateOfferingsMutationResult = Awaited<
  ReturnType<typeof createOfferings>
>;
export const useCreateOfferingsKey = "CreateOfferings";
export const UseCreateOfferingsKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateOfferingsKey,
  ...(mutationKey ?? []),
];
export type AddOfferingSeatTypesMutationResult = Awaited<
  ReturnType<typeof addOfferingSeatTypes>
>;
export const useAddOfferingSeatTypesKey = "AddOfferingSeatTypes";
export const UseAddOfferingSeatTypesKeyFn = (mutationKey?: Array<unknown>) => [
  useAddOfferingSeatTypesKey,
  ...(mutationKey ?? []),
];
export type CreateBoundaryConnectionsMutationResult = Awaited<
  ReturnType<typeof createBoundaryConnections>
>;
export const useCreateBoundaryConnectionsKey = "CreateBoundaryConnections";
export const UseCreateBoundaryConnectionsKeyFn = (
  mutationKey?: Array<unknown>
) => [useCreateBoundaryConnectionsKey, ...(mutationKey ?? [])];
export type PostBoundariesMutationResult = Awaited<
  ReturnType<typeof postBoundaries>
>;
export const usePostBoundariesKey = "PostBoundaries";
export const UsePostBoundariesKeyFn = (mutationKey?: Array<unknown>) => [
  usePostBoundariesKey,
  ...(mutationKey ?? []),
];
export type ExportCapacitiesBySchoolAndEnrollmentPeriodMutationResult = Awaited<
  ReturnType<typeof exportCapacitiesBySchoolAndEnrollmentPeriod>
>;
export const useExportCapacitiesBySchoolAndEnrollmentPeriodKey =
  "ExportCapacitiesBySchoolAndEnrollmentPeriod";
export const UseExportCapacitiesBySchoolAndEnrollmentPeriodKeyFn = (
  mutationKey?: Array<unknown>
) => [
  useExportCapacitiesBySchoolAndEnrollmentPeriodKey,
  ...(mutationKey ?? []),
];
export type ExportCapacitiesByEnrollmentPeriodMutationResult = Awaited<
  ReturnType<typeof exportCapacitiesByEnrollmentPeriod>
>;
export const useExportCapacitiesByEnrollmentPeriodKey =
  "ExportCapacitiesByEnrollmentPeriod";
export const UseExportCapacitiesByEnrollmentPeriodKeyFn = (
  mutationKey?: Array<unknown>
) => [useExportCapacitiesByEnrollmentPeriodKey, ...(mutationKey ?? [])];
export type ImportCapacitiesByEnrollmentPeriodMutationResult = Awaited<
  ReturnType<typeof importCapacitiesByEnrollmentPeriod>
>;
export const useImportCapacitiesByEnrollmentPeriodKey =
  "ImportCapacitiesByEnrollmentPeriod";
export const UseImportCapacitiesByEnrollmentPeriodKeyFn = (
  mutationKey?: Array<unknown>
) => [useImportCapacitiesByEnrollmentPeriodKey, ...(mutationKey ?? [])];
export type UpdateCapacitiesByEnrollmentPeriodMutationResult = Awaited<
  ReturnType<typeof updateCapacitiesByEnrollmentPeriod>
>;
export const useUpdateCapacitiesByEnrollmentPeriodKey =
  "UpdateCapacitiesByEnrollmentPeriod";
export const UseUpdateCapacitiesByEnrollmentPeriodKeyFn = (
  mutationKey?: Array<unknown>
) => [useUpdateCapacitiesByEnrollmentPeriodKey, ...(mutationKey ?? [])];
export type CreateFamilyMutationResult = Awaited<
  ReturnType<typeof createFamily>
>;
export const useCreateFamilyKey = "CreateFamily";
export const UseCreateFamilyKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateFamilyKey,
  ...(mutationKey ?? []),
];
export type CreateMatchRunMutationResult = Awaited<
  ReturnType<typeof createMatchRun>
>;
export const useCreateMatchRunKey = "CreateMatchRun";
export const UseCreateMatchRunKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateMatchRunKey,
  ...(mutationKey ?? []),
];
export type PublishMatchRunMutationResult = Awaited<
  ReturnType<typeof publishMatchRun>
>;
export const usePublishMatchRunKey = "PublishMatchRun";
export const UsePublishMatchRunKeyFn = (mutationKey?: Array<unknown>) => [
  usePublishMatchRunKey,
  ...(mutationKey ?? []),
];
export type ResetTeamMemberMfaMutationResult = Awaited<
  ReturnType<typeof resetTeamMemberMfa>
>;
export const useResetTeamMemberMfaKey = "ResetTeamMemberMfa";
export const UseResetTeamMemberMfaKeyFn = (mutationKey?: Array<unknown>) => [
  useResetTeamMemberMfaKey,
  ...(mutationKey ?? []),
];
export type CreateTeamMemberMutationResult = Awaited<
  ReturnType<typeof createTeamMember>
>;
export const useCreateTeamMemberKey = "CreateTeamMember";
export const UseCreateTeamMemberKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateTeamMemberKey,
  ...(mutationKey ?? []),
];
export type SendPasswordResetMutationResult = Awaited<
  ReturnType<typeof sendPasswordReset>
>;
export const useSendPasswordResetKey = "SendPasswordReset";
export const UseSendPasswordResetKeyFn = (mutationKey?: Array<unknown>) => [
  useSendPasswordResetKey,
  ...(mutationKey ?? []),
];
export type CreateApiCredentialMutationResult = Awaited<
  ReturnType<typeof createApiCredential>
>;
export const useCreateApiCredentialKey = "CreateApiCredential";
export const UseCreateApiCredentialKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateApiCredentialKey,
  ...(mutationKey ?? []),
];
export type RotateApiCredentialSecretMutationResult = Awaited<
  ReturnType<typeof rotateApiCredentialSecret>
>;
export const useRotateApiCredentialSecretKey = "RotateApiCredentialSecret";
export const UseRotateApiCredentialSecretKeyFn = (
  mutationKey?: Array<unknown>
) => [useRotateApiCredentialSecretKey, ...(mutationKey ?? [])];
export type CreateOrganizationMutationResult = Awaited<
  ReturnType<typeof createOrganization>
>;
export const useCreateOrganizationKey = "CreateOrganization";
export const UseCreateOrganizationKeyFn = (mutationKey?: Array<unknown>) => [
  useCreateOrganizationKey,
  ...(mutationKey ?? []),
];
export type GenerateUploadUrlMutationResult = Awaited<
  ReturnType<typeof generateUploadUrl>
>;
export const useGenerateUploadUrlKey = "GenerateUploadUrl";
export const UseGenerateUploadUrlKeyFn = (mutationKey?: Array<unknown>) => [
  useGenerateUploadUrlKey,
  ...(mutationKey ?? []),
];
export type GenerateBannerImageUploadUrlMutationResult = Awaited<
  ReturnType<typeof generateBannerImageUploadUrl>
>;
export const useGenerateBannerImageUploadUrlKey =
  "GenerateBannerImageUploadUrl";
export const UseGenerateBannerImageUploadUrlKeyFn = (
  mutationKey?: Array<unknown>
) => [useGenerateBannerImageUploadUrlKey, ...(mutationKey ?? [])];
export type UpdateOrganizationConfigMutationResult = Awaited<
  ReturnType<typeof updateOrganizationConfig>
>;
export const useUpdateOrganizationConfigKey = "UpdateOrganizationConfig";
export const UseUpdateOrganizationConfigKeyFn = (
  mutationKey?: Array<unknown>
) => [useUpdateOrganizationConfigKey, ...(mutationKey ?? [])];
export type ConnectStripeAccountMutationResult = Awaited<
  ReturnType<typeof connectStripeAccount>
>;
export const useConnectStripeAccountKey = "ConnectStripeAccount";
export const UseConnectStripeAccountKeyFn = (mutationKey?: Array<unknown>) => [
  useConnectStripeAccountKey,
  ...(mutationKey ?? []),
];
export type DisconnectStripeAccountMutationResult = Awaited<
  ReturnType<typeof disconnectStripeAccount>
>;
export const useDisconnectStripeAccountKey = "DisconnectStripeAccount";
export const UseDisconnectStripeAccountKeyFn = (
  mutationKey?: Array<unknown>
) => [useDisconnectStripeAccountKey, ...(mutationKey ?? [])];
export type CreatePaymentTemplateMutationResult = Awaited<
  ReturnType<typeof createPaymentTemplate>
>;
export const useCreatePaymentTemplateKey = "CreatePaymentTemplate";
export const UseCreatePaymentTemplateKeyFn = (mutationKey?: Array<unknown>) => [
  useCreatePaymentTemplateKey,
  ...(mutationKey ?? []),
];
export type CreatePaymentsMutationResult = Awaited<
  ReturnType<typeof createPayments>
>;
export const useCreatePaymentsKey = "CreatePayments";
export const UseCreatePaymentsKeyFn = (mutationKey?: Array<unknown>) => [
  useCreatePaymentsKey,
  ...(mutationKey ?? []),
];
export type CreateRuleExecutionsForMeMutationResult = Awaited<
  ReturnType<typeof createRuleExecutionsForMe>
>;
export const useCreateRuleExecutionsForMeKey = "CreateRuleExecutionsForMe";
export const UseCreateRuleExecutionsForMeKeyFn = (
  mutationKey?: Array<unknown>
) => [useCreateRuleExecutionsForMeKey, ...(mutationKey ?? [])];
export type ResendVerificationEmailMutationResult = Awaited<
  ReturnType<typeof resendVerificationEmail>
>;
export const useResendVerificationEmailKey = "ResendVerificationEmail";
export const UseResendVerificationEmailKeyFn = (
  mutationKey?: Array<unknown>
) => [useResendVerificationEmailKey, ...(mutationKey ?? [])];
export type CheckoutMutationResult = Awaited<ReturnType<typeof checkout>>;
export const useCheckoutKey = "Checkout";
export const UseCheckoutKeyFn = (mutationKey?: Array<unknown>) => [
  useCheckoutKey,
  ...(mutationKey ?? []),
];
export type UpdateFormsStatusForAdminMutationResult = Awaited<
  ReturnType<typeof updateFormsStatusForAdmin>
>;
export const useUpdateFormsStatusForAdminKey = "UpdateFormsStatusForAdmin";
export const UseUpdateFormsStatusForAdminKeyFn = (
  mutationKey?: Array<unknown>
) => [useUpdateFormsStatusForAdminKey, ...(mutationKey ?? [])];
export type PutAnswersMutationResult = Awaited<ReturnType<typeof putAnswers>>;
export const usePutAnswersKey = "PutAnswers";
export const UsePutAnswersKeyFn = (mutationKey?: Array<unknown>) => [
  usePutAnswersKey,
  ...(mutationKey ?? []),
];
export type PutAnswerMutationResult = Awaited<ReturnType<typeof putAnswer>>;
export const usePutAnswerKey = "PutAnswer";
export const UsePutAnswerKeyFn = (mutationKey?: Array<unknown>) => [
  usePutAnswerKey,
  ...(mutationKey ?? []),
];
export type BulkAcceptOfferMutationResult = Awaited<
  ReturnType<typeof bulkAcceptOffer>
>;
export const useBulkAcceptOfferKey = "BulkAcceptOffer";
export const UseBulkAcceptOfferKeyFn = (mutationKey?: Array<unknown>) => [
  useBulkAcceptOfferKey,
  ...(mutationKey ?? []),
];
export type BulkDeclineOfferMutationResult = Awaited<
  ReturnType<typeof bulkDeclineOffer>
>;
export const useBulkDeclineOfferKey = "BulkDeclineOffer";
export const UseBulkDeclineOfferKeyFn = (mutationKey?: Array<unknown>) => [
  useBulkDeclineOfferKey,
  ...(mutationKey ?? []),
];
export type BulkRevokeOfferMutationResult = Awaited<
  ReturnType<typeof bulkRevokeOffer>
>;
export const useBulkRevokeOfferKey = "BulkRevokeOffer";
export const UseBulkRevokeOfferKeyFn = (mutationKey?: Array<unknown>) => [
  useBulkRevokeOfferKey,
  ...(mutationKey ?? []),
];
export type UpdateOfferConfigurationMutationResult = Awaited<
  ReturnType<typeof updateOfferConfiguration>
>;
export const useUpdateOfferConfigurationKey = "UpdateOfferConfiguration";
export const UseUpdateOfferConfigurationKeyFn = (
  mutationKey?: Array<unknown>
) => [useUpdateOfferConfigurationKey, ...(mutationKey ?? [])];
export type ExcludeMutationResult = Awaited<ReturnType<typeof exclude>>;
export const useExcludeKey = "Exclude";
export const UseExcludeKeyFn = (mutationKey?: Array<unknown>) => [
  useExcludeKey,
  ...(mutationKey ?? []),
];
export type UpdateTagGroupMutationResult = Awaited<
  ReturnType<typeof updateTagGroup>
>;
export const useUpdateTagGroupKey = "UpdateTagGroup";
export const UseUpdateTagGroupKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateTagGroupKey,
  ...(mutationKey ?? []),
];
export type UpdateTagMutationResult = Awaited<ReturnType<typeof updateTag>>;
export const useUpdateTagKey = "UpdateTag";
export const UseUpdateTagKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateTagKey,
  ...(mutationKey ?? []),
];
export type UpdateFormTemplateMutationResult = Awaited<
  ReturnType<typeof updateFormTemplate>
>;
export const useUpdateFormTemplateKey = "UpdateFormTemplate";
export const UseUpdateFormTemplateKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateFormTemplateKey,
  ...(mutationKey ?? []),
];
export type UpdateFormTemplateSettingsMutationResult = Awaited<
  ReturnType<typeof updateFormTemplateSettings>
>;
export const useUpdateFormTemplateSettingsKey = "UpdateFormTemplateSettings";
export const UseUpdateFormTemplateSettingsKeyFn = (
  mutationKey?: Array<unknown>
) => [useUpdateFormTemplateSettingsKey, ...(mutationKey ?? [])];
export type UpdateFormSchemaMutationResult = Awaited<
  ReturnType<typeof updateFormSchema>
>;
export const useUpdateFormSchemaKey = "UpdateFormSchema";
export const UseUpdateFormSchemaKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateFormSchemaKey,
  ...(mutationKey ?? []),
];
export type UpdateFormRuleMutationResult = Awaited<
  ReturnType<typeof updateFormRule>
>;
export const useUpdateFormRuleKey = "UpdateFormRule";
export const UseUpdateFormRuleKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateFormRuleKey,
  ...(mutationKey ?? []),
];
export type UpdateFormRuleActiveStatusMutationResult = Awaited<
  ReturnType<typeof updateFormRuleActiveStatus>
>;
export const useUpdateFormRuleActiveStatusKey = "UpdateFormRuleActiveStatus";
export const UseUpdateFormRuleActiveStatusKeyFn = (
  mutationKey?: Array<unknown>
) => [useUpdateFormRuleActiveStatusKey, ...(mutationKey ?? [])];
export type UpdateOfferingCategoryMutationResult = Awaited<
  ReturnType<typeof updateOfferingCategory>
>;
export const useUpdateOfferingCategoryKey = "UpdateOfferingCategory";
export const UseUpdateOfferingCategoryKeyFn = (
  mutationKey?: Array<unknown>
) => [useUpdateOfferingCategoryKey, ...(mutationKey ?? [])];
export type UpdateBoundaryConnectionsMutationResult = Awaited<
  ReturnType<typeof updateBoundaryConnections>
>;
export const useUpdateBoundaryConnectionsKey = "UpdateBoundaryConnections";
export const UseUpdateBoundaryConnectionsKeyFn = (
  mutationKey?: Array<unknown>
) => [useUpdateBoundaryConnectionsKey, ...(mutationKey ?? [])];
export type UpdateBoundaryByIdMutationResult = Awaited<
  ReturnType<typeof updateBoundaryById>
>;
export const useUpdateBoundaryByIdKey = "UpdateBoundaryById";
export const UseUpdateBoundaryByIdKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateBoundaryByIdKey,
  ...(mutationKey ?? []),
];
export type UpdateCapacitiesConfigByEnrollmentPeriodMutationResult = Awaited<
  ReturnType<typeof updateCapacitiesConfigByEnrollmentPeriod>
>;
export const useUpdateCapacitiesConfigByEnrollmentPeriodKey =
  "UpdateCapacitiesConfigByEnrollmentPeriod";
export const UseUpdateCapacitiesConfigByEnrollmentPeriodKeyFn = (
  mutationKey?: Array<unknown>
) => [useUpdateCapacitiesConfigByEnrollmentPeriodKey, ...(mutationKey ?? [])];
export type CreateLoginPrefillTokenMutationResult = Awaited<
  ReturnType<typeof createLoginPrefillToken>
>;
export const useCreateLoginPrefillTokenKey = "CreateLoginPrefillToken";
export const UseCreateLoginPrefillTokenKeyFn = (
  mutationKey?: Array<unknown>
) => [useCreateLoginPrefillTokenKey, ...(mutationKey ?? [])];
export type EditTeamMemberMutationResult = Awaited<
  ReturnType<typeof editTeamMember>
>;
export const useEditTeamMemberKey = "EditTeamMember";
export const UseEditTeamMemberKeyFn = (mutationKey?: Array<unknown>) => [
  useEditTeamMemberKey,
  ...(mutationKey ?? []),
];
export type UpdateApiCredentialMutationResult = Awaited<
  ReturnType<typeof updateApiCredential>
>;
export const useUpdateApiCredentialKey = "UpdateApiCredential";
export const UseUpdateApiCredentialKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdateApiCredentialKey,
  ...(mutationKey ?? []),
];
export type CancelPaymentMutationResult = Awaited<
  ReturnType<typeof cancelPayment>
>;
export const useCancelPaymentKey = "CancelPayment";
export const UseCancelPaymentKeyFn = (mutationKey?: Array<unknown>) => [
  useCancelPaymentKey,
  ...(mutationKey ?? []),
];
export type WithdrawFromWaitlistMutationResult = Awaited<
  ReturnType<typeof withdrawFromWaitlist>
>;
export const useWithdrawFromWaitlistKey = "WithdrawFromWaitlist";
export const UseWithdrawFromWaitlistKeyFn = (mutationKey?: Array<unknown>) => [
  useWithdrawFromWaitlistKey,
  ...(mutationKey ?? []),
];
export type AcceptOfferMutationResult = Awaited<ReturnType<typeof acceptOffer>>;
export const useAcceptOfferKey = "AcceptOffer";
export const UseAcceptOfferKeyFn = (mutationKey?: Array<unknown>) => [
  useAcceptOfferKey,
  ...(mutationKey ?? []),
];
export type DeclineOfferMutationResult = Awaited<
  ReturnType<typeof declineOffer>
>;
export const useDeclineOfferKey = "DeclineOffer";
export const UseDeclineOfferKeyFn = (mutationKey?: Array<unknown>) => [
  useDeclineOfferKey,
  ...(mutationKey ?? []),
];
export type PutAnswersForMeMutationResult = Awaited<
  ReturnType<typeof putAnswersForMe>
>;
export const usePutAnswersForMeKey = "PutAnswersForMe";
export const UsePutAnswersForMeKeyFn = (mutationKey?: Array<unknown>) => [
  usePutAnswersForMeKey,
  ...(mutationKey ?? []),
];
export type PutAnswerForMeMutationResult = Awaited<
  ReturnType<typeof putAnswerForMe>
>;
export const usePutAnswerForMeKey = "PutAnswerForMe";
export const UsePutAnswerForMeKeyFn = (mutationKey?: Array<unknown>) => [
  usePutAnswerForMeKey,
  ...(mutationKey ?? []),
];
export type ResetFormForMeMutationResult = Awaited<
  ReturnType<typeof resetFormForMe>
>;
export const useResetFormForMeKey = "ResetFormForMe";
export const UseResetFormForMeKeyFn = (mutationKey?: Array<unknown>) => [
  useResetFormForMeKey,
  ...(mutationKey ?? []),
];
export type SubmitFormForMeMutationResult = Awaited<
  ReturnType<typeof submitFormForMe>
>;
export const useSubmitFormForMeKey = "SubmitFormForMe";
export const UseSubmitFormForMeKeyFn = (mutationKey?: Array<unknown>) => [
  useSubmitFormForMeKey,
  ...(mutationKey ?? []),
];
export type DeleteFormForMeMutationResult = Awaited<
  ReturnType<typeof deleteFormForMe>
>;
export const useDeleteFormForMeKey = "DeleteFormForMe";
export const UseDeleteFormForMeKeyFn = (mutationKey?: Array<unknown>) => [
  useDeleteFormForMeKey,
  ...(mutationKey ?? []),
];
export type BulkSetOfferExpirationMutationResult = Awaited<
  ReturnType<typeof bulkSetOfferExpiration>
>;
export const useBulkSetOfferExpirationKey = "BulkSetOfferExpiration";
export const UseBulkSetOfferExpirationKeyFn = (
  mutationKey?: Array<unknown>
) => [useBulkSetOfferExpirationKey, ...(mutationKey ?? [])];
export type ArchiveTeamMembersMutationResult = Awaited<
  ReturnType<typeof archiveTeamMembers>
>;
export const useArchiveTeamMembersKey = "ArchiveTeamMembers";
export const UseArchiveTeamMembersKeyFn = (mutationKey?: Array<unknown>) => [
  useArchiveTeamMembersKey,
  ...(mutationKey ?? []),
];
export type UpdatePaymentTemplateMutationResult = Awaited<
  ReturnType<typeof updatePaymentTemplate>
>;
export const useUpdatePaymentTemplateKey = "UpdatePaymentTemplate";
export const UseUpdatePaymentTemplateKeyFn = (mutationKey?: Array<unknown>) => [
  useUpdatePaymentTemplateKey,
  ...(mutationKey ?? []),
];
export type ClearAnswerMutationResult = Awaited<ReturnType<typeof clearAnswer>>;
export const useClearAnswerKey = "ClearAnswer";
export const UseClearAnswerKeyFn = (mutationKey?: Array<unknown>) => [
  useClearAnswerKey,
  ...(mutationKey ?? []),
];
export type DeleteOfferConfigurationMutationResult = Awaited<
  ReturnType<typeof deleteOfferConfiguration>
>;
export const useDeleteOfferConfigurationKey = "DeleteOfferConfiguration";
export const UseDeleteOfferConfigurationKeyFn = (
  mutationKey?: Array<unknown>
) => [useDeleteOfferConfigurationKey, ...(mutationKey ?? [])];
export type DeleteWaitlistsMutationResult = Awaited<
  ReturnType<typeof deleteWaitlists>
>;
export const useDeleteWaitlistsKey = "DeleteWaitlists";
export const UseDeleteWaitlistsKeyFn = (mutationKey?: Array<unknown>) => [
  useDeleteWaitlistsKey,
  ...(mutationKey ?? []),
];
export type ClearSubStatusMutationResult = Awaited<
  ReturnType<typeof clearSubStatus>
>;
export const useClearSubStatusKey = "ClearSubStatus";
export const UseClearSubStatusKeyFn = (mutationKey?: Array<unknown>) => [
  useClearSubStatusKey,
  ...(mutationKey ?? []),
];
export type RemoveFormTagMutationResult = Awaited<
  ReturnType<typeof removeFormTag>
>;
export const useRemoveFormTagKey = "RemoveFormTag";
export const UseRemoveFormTagKeyFn = (mutationKey?: Array<unknown>) => [
  useRemoveFormTagKey,
  ...(mutationKey ?? []),
];
export type RemoveFormSchoolTagMutationResult = Awaited<
  ReturnType<typeof removeFormSchoolTag>
>;
export const useRemoveFormSchoolTagKey = "RemoveFormSchoolTag";
export const UseRemoveFormSchoolTagKeyFn = (mutationKey?: Array<unknown>) => [
  useRemoveFormSchoolTagKey,
  ...(mutationKey ?? []),
];
export type DeleteTagGroupMutationResult = Awaited<
  ReturnType<typeof deleteTagGroup>
>;
export const useDeleteTagGroupKey = "DeleteTagGroup";
export const UseDeleteTagGroupKeyFn = (mutationKey?: Array<unknown>) => [
  useDeleteTagGroupKey,
  ...(mutationKey ?? []),
];
export type DeleteTagMutationResult = Awaited<ReturnType<typeof deleteTag>>;
export const useDeleteTagKey = "DeleteTag";
export const UseDeleteTagKeyFn = (mutationKey?: Array<unknown>) => [
  useDeleteTagKey,
  ...(mutationKey ?? []),
];
export type DeleteUnpublishedFormSchemaMutationResult = Awaited<
  ReturnType<typeof deleteUnpublishedFormSchema>
>;
export const useDeleteUnpublishedFormSchemaKey = "DeleteUnpublishedFormSchema";
export const UseDeleteUnpublishedFormSchemaKeyFn = (
  mutationKey?: Array<unknown>
) => [useDeleteUnpublishedFormSchemaKey, ...(mutationKey ?? [])];
export type DeleteFormRuleMutationResult = Awaited<
  ReturnType<typeof deleteFormRule>
>;
export const useDeleteFormRuleKey = "DeleteFormRule";
export const UseDeleteFormRuleKeyFn = (mutationKey?: Array<unknown>) => [
  useDeleteFormRuleKey,
  ...(mutationKey ?? []),
];
export type DeleteOfferingCategoryMutationResult = Awaited<
  ReturnType<typeof deleteOfferingCategory>
>;
export const useDeleteOfferingCategoryKey = "DeleteOfferingCategory";
export const UseDeleteOfferingCategoryKeyFn = (
  mutationKey?: Array<unknown>
) => [useDeleteOfferingCategoryKey, ...(mutationKey ?? [])];
export type DeleteOfferingMutationResult = Awaited<
  ReturnType<typeof deleteOffering>
>;
export const useDeleteOfferingKey = "DeleteOffering";
export const UseDeleteOfferingKeyFn = (mutationKey?: Array<unknown>) => [
  useDeleteOfferingKey,
  ...(mutationKey ?? []),
];
export type DeleteOfferingSeatTypeMutationResult = Awaited<
  ReturnType<typeof deleteOfferingSeatType>
>;
export const useDeleteOfferingSeatTypeKey = "DeleteOfferingSeatType";
export const UseDeleteOfferingSeatTypeKeyFn = (
  mutationKey?: Array<unknown>
) => [useDeleteOfferingSeatTypeKey, ...(mutationKey ?? [])];
export type DeleteBoundaryConnectionsMutationResult = Awaited<
  ReturnType<typeof deleteBoundaryConnections>
>;
export const useDeleteBoundaryConnectionsKey = "DeleteBoundaryConnections";
export const UseDeleteBoundaryConnectionsKeyFn = (
  mutationKey?: Array<unknown>
) => [useDeleteBoundaryConnectionsKey, ...(mutationKey ?? [])];
export type DeleteBoundariesMutationResult = Awaited<
  ReturnType<typeof deleteBoundaries>
>;
export const useDeleteBoundariesKey = "DeleteBoundaries";
export const UseDeleteBoundariesKeyFn = (mutationKey?: Array<unknown>) => [
  useDeleteBoundariesKey,
  ...(mutationKey ?? []),
];
export type DeleteApiCredentialMutationResult = Awaited<
  ReturnType<typeof deleteApiCredential>
>;
export const useDeleteApiCredentialKey = "DeleteApiCredential";
export const UseDeleteApiCredentialKeyFn = (mutationKey?: Array<unknown>) => [
  useDeleteApiCredentialKey,
  ...(mutationKey ?? []),
];
export type DeletePaymentTemplateMutationResult = Awaited<
  ReturnType<typeof deletePaymentTemplate>
>;
export const useDeletePaymentTemplateKey = "DeletePaymentTemplate";
export const UseDeletePaymentTemplateKeyFn = (mutationKey?: Array<unknown>) => [
  useDeletePaymentTemplateKey,
  ...(mutationKey ?? []),
];
export type ClearAnswerForMeMutationResult = Awaited<
  ReturnType<typeof clearAnswerForMe>
>;
export const useClearAnswerForMeKey = "ClearAnswerForMe";
export const UseClearAnswerForMeKeyFn = (mutationKey?: Array<unknown>) => [
  useClearAnswerForMeKey,
  ...(mutationKey ?? []),
];
